module.exports = __webpack_public_path__ + "static/media/received_coupon_1.da66369a.svg";